import { Base } from "../../../../base/components/base"
import { Img } from "../../../../base/components/native/img"
import { TABLE_DIM } from "../../../../configs/config"
import { IMAGES } from "../../../../configs/images"
import { RateTh } from "./rate-th"
import { RateTr } from "./rate-tr"

export const RateHeader = () => {

    const base = RateTr()

    const title = RateTh('عنوان')
    title.cssClass({ width: TABLE_DIM.NAME + 'px', textAlign: 'right' })

    const rate = RateTh('نــرخ')
    rate.cssClass({ width: TABLE_DIM.PRICE + 'px', textAlign: 'right', paddingRight: '10px' })

    const article = RateTh()
    article.cssClass({ width: '300px', textAlign: 'left', paddingLeft: '20px' })
    const articleIcon = Img(IMAGES.ICONS.ARTICLE, { width: 18 })
    articleIcon.el.setAttribute('title', 'لینک مقاله مرتبط')
    article.append(articleIcon)

    const db = RateTh()
    db.cssClass({ width: '30px', paddingRight: '10px' })
    const dbIcon = Img(IMAGES.ICONS.DATABASE, { width: 20, })
    dbIcon.el.setAttribute('title', 'بروزرسانی دیتابیس')
    db.append(dbIcon)

    // const telegram = RateTh()
    // telegram.cssClass({ width: '30px', paddingRight: '10px' })
    // const telegramIcon = Img(IMAGES.ICONS.TELEGRAM, { width: 24 })
    // telegramIcon.el.setAttribute('title', 'ارسال به تلگرام')
    // telegram.append(telegramIcon)

    base.append(title, rate, article, db)

    return base
}